import React, { useContext } from 'react';
import { Switch, BrowserRouter, Route, Redirect } from "react-router-dom";
import SessionWrapper, { SessionContext } from "./hooks/wrappers/SessionWrapper";
import UsersWrapper from "./hooks/wrappers/UsersWrapper";
import { modelsProvWrapper } from "./components/wrappers/modelsProvWrapper";
import { modalProvControl } from "./components/wrappers/modalProvControl";
import Loading from "./components/shared/wait/Loading";
import Navigation from "./components/shared/nav/Navigation";
import Estadistics from "./components/pages/Estadistics";
import Vespas from "./components/pages/Vespas";
import Bookings from "./components/pages/Bookings";
import Users from "./components/pages/Users";
import Login from "./components/pages/Login";
import './App.css';
import NewUser from "./components/pages/NewUser";
import Settings from "./components/pages/Settings";


const App = () =>
  <SessionWrapper>
    <UsersWrapper>
      <TestRouter />
    </UsersWrapper>
  </SessionWrapper>


const Router = () => {
  const { isLoggedIn } = useContext(SessionContext)

  if (
    isLoggedIn === null
  ) {
    return <Loading/>
  }

  return (
    <BrowserRouter>
      <Navigation>
        <Switch>
          {!isLoggedIn && <Route exact path="/login" component={Login}/>}
          {!isLoggedIn && <Redirect to="/login"/>}

          <Route exact path="/bookings" component={Bookings}/>
          <Route exact path="/vespas" component={Vespas}/>
          <Route exact path="/users" component={Users}/>
          <Route exact path="/estadistics" component={Estadistics}/>
          <Route exact path="/new-client" component={NewUser}/>
          <Route exact path="/settings" component={Settings}/>
          <Redirect to="/bookings"/>
        </Switch>
      </Navigation>
    </BrowserRouter>
  );
};
const TestRouter = modelsProvWrapper(modalProvControl(Router))

// export default modelsProvWrapper(rentalsProvWrapper(modalProvControl(App)));
export default App;
